export enum ColumnNames {
  type = 'type',
  createdAt = 'createdAt',
  name = 'name',
  comment = 'comment',
  tags = 'tags',
  actions = 'actions'
}

export const displayedColumns: ColumnNames[] = [
  ColumnNames.type,
  ColumnNames.createdAt,
  ColumnNames.name,
  ColumnNames.comment,
  ColumnNames.tags,
  ColumnNames.actions
];
